import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Textfield } from "../..";
var HTML_TEMPLATE = "\n<od-box-container>\n  <div class=\"od-reset-password-content\" header></div>\n  <div class=\"od-reset-password-content\" body>\n    <label class=\"od-reset-password-resetPassword\">\n      {{'ResetPassword.resetPassword'| translate}}\n    </label>\n    <od-textfield #emailTF type=\"email\"  iconName=\"odi_email\" class=\"od-reset-password-textfield\"\n                  [placeholder]=\"'ResetPassword.email' | translate\"></od-textfield>\n    <od-button size=\"inherit\" class=\"od-reset-password-button-reset-password\" (click)=\"onResetPassword()\"\n               [text]=\"'ResetPassword.resetPassword' | translate\" [color]=\"buttonTextColor\" [bgColor]=\"buttonColor\"></od-button>\n  </div>\n</od-box-container>\n";
var CSS_STYLE = "\n.od-reset-password-content[header] {\n  padding: 20px;\n}\n\n.od-reset-password-content[body] {\n  width: 100%;\n  border-radius: 4px;\n  border: solid 1px #dfe3e9;\n  margin-bottom: 40px;\n  box-sizing: border-box;\n  display: flex;\n  background-color: white;\n  padding: 40px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.od-reset-password-content[body] .od-reset-password-resetPassword {\n  font-size: 20px;\n  margin-bottom: 28px;\n  width:100%;\n  text-align: center;\n}\n\n.od-reset-password-content[body] .od-reset-password-textfield,\n.od-reset-password-content[body] .od-reset-password-button-reset-password {\n  margin-top: 12px;\n  margin-bottom: 8px;\n  width: 100%;\n}\n";
var ResetPassword = /** @class */ (function () {
    function ResetPassword() {
        this.odResetPassword = new EventEmitter();
        if (this.buttonColor == null)
            this.buttonColor = "#25aed8";
        if (this.buttonTextColor == null)
            this.buttonTextColor = "#FFFFFF";
    }
    ResetPassword.prototype.onResetPassword = function () {
        this.odResetPassword.emit(this.emailTF.value);
    };
    ResetPassword.decorators = [
        { type: Component, args: [{
                    selector: 'od-reset-password',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    ResetPassword.ctorParameters = function () { return []; };
    ResetPassword.propDecorators = {
        "buttonTextColor": [{ type: Input },],
        "buttonColor": [{ type: Input },],
        "emailTF": [{ type: ViewChild, args: ['emailTF',] },],
        "odResetPassword": [{ type: Output },],
    };
    return ResetPassword;
}());
export { ResetPassword };
//# sourceMappingURL=reset-password.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/sign/reset-password.js
// module id = 445
// module chunks = 14